// Dark Theme (Default - Purple accent)
export const darkTheme = {
  bg: "#090917",
  bgLight: "#1C1E27",
  bgGradient1: "rgba(204, 0, 187, 0.15)",
  bgGradient2: "rgba(0, 70, 209, 0.15)",
  primary: "#854CE6",
  primaryRgb: "133, 76, 230",
  primaryGradient: "linear-gradient(225deg, hsla(271, 100%, 50%, 1), hsla(294, 100%, 50%, 1))",
  primaryGradient135: "linear-gradient(135deg, #854CE6, #B24CF3)",
  primaryLight: "#B24CF3",
  starColor: "#f272c8",
  text_primary: "#F2F3F4",
  text_secondary: "#b1b2b3",
  card: "#171721",
  card_light: "#191924",
  cardBg: "rgba(17, 25, 40, 0.83)",
  cardBorder: "rgba(255, 255, 255, 0.125)",
  cardShadow: "rgba(23, 92, 230, 0.15) 0px 4px 24px",
  timelineColor: "#854CE6",
  timelineArrow: "rgba(255, 255, 255, 0.3)",
  button: "#854CE6",
  white: "#FFFFFF",
  black: "#000000",
  navBg: "rgba(9, 9, 23, 0.92)",
  navBorder: "rgba(133, 76, 230, 0.1)",
  loaderBg: "#090917",
  footerBg: "#090917",
  inputBg: "transparent",
  inputBorder: "#854CE6",
  scrollbarTrack: "#222a35",
  scrollbarThumb: "#575c66",
  scrollbarThumbHover: "#626970",
};

// Light Theme (Warm cream bg, vibrant purple for contrast)
export const lightTheme = {
  bg: "#FEFCF3",
  bgLight: "#FFF8E1",
  bgGradient1: "rgba(108, 63, 197, 0.05)",
  bgGradient2: "rgba(180, 140, 50, 0.04)",
  primary: "#7B3FE4",
  primaryRgb: "123, 63, 228",
  primaryGradient: "linear-gradient(225deg, #7B3FE4, #A855F7)",
  primaryGradient135: "linear-gradient(135deg, #7B3FE4, #A855F7)",
  primaryLight: "#A855F7",
  starColor: "#7B3FE4",
  text_primary: "#1e1e2e",
  text_secondary: "#4a4a68",
  card: "#FFFDF7",
  card_light: "#FFF9EB",
  cardBg: "rgba(255, 252, 243, 0.92)",
  cardBorder: "rgba(123, 63, 228, 0.12)",
  cardShadow: "rgba(123, 63, 228, 0.08) 0px 4px 24px",
  timelineColor: "#7B3FE4",
  timelineArrow: "rgba(123, 63, 228, 0.25)",
  button: "#7B3FE4",
  white: "#FFFFFF",
  black: "#000000",
  navBg: "rgba(254, 252, 243, 0.92)",
  navBorder: "rgba(123, 63, 228, 0.1)",
  loaderBg: "#FEFCF3",
  footerBg: "#1e1e2e",
  inputBg: "#FFFDF7",
  inputBorder: "#7B3FE4",
  scrollbarTrack: "#F5ECD7",
  scrollbarThumb: "#D4C5A0",
  scrollbarThumbHover: "#BFB08A",
};

// Green Theme (Dark bg, neon green accent)
export const greenTheme = {
  bg: "#080d0b",
  bgLight: "#0f1f18",
  bgGradient1: "rgba(0, 200, 83, 0.1)",
  bgGradient2: "rgba(0, 150, 136, 0.08)",
  primary: "#00E676",
  primaryRgb: "0, 230, 118",
  primaryGradient: "linear-gradient(225deg, #00E676, #00C853)",
  primaryGradient135: "linear-gradient(135deg, #00C853, #69F0AE)",
  primaryLight: "#69F0AE",
  starColor: "#00E676",
  text_primary: "#E0F2E9",
  text_secondary: "#81C784",
  card: "#0d1a14",
  card_light: "#112018",
  cardBg: "rgba(13, 26, 20, 0.85)",
  cardBorder: "rgba(0, 230, 118, 0.12)",
  cardShadow: "rgba(0, 200, 83, 0.12) 0px 4px 24px",
  timelineColor: "#00E676",
  timelineArrow: "rgba(0, 230, 118, 0.3)",
  button: "#00E676",
  white: "#FFFFFF",
  black: "#000000",
  navBg: "rgba(8, 13, 11, 0.92)",
  navBorder: "rgba(0, 230, 118, 0.1)",
  loaderBg: "#080d0b",
  footerBg: "#080d0b",
  inputBg: "transparent",
  inputBorder: "#00E676",
  scrollbarTrack: "#0f1f18",
  scrollbarThumb: "#1a3d2a",
  scrollbarThumbHover: "#2a5e40",
};

// Orange Theme (Dark bg, warm orange accent)
export const orangeTheme = {
  bg: "#0d0906",
  bgLight: "#1f1408",
  bgGradient1: "rgba(255, 109, 0, 0.1)",
  bgGradient2: "rgba(255, 152, 0, 0.06)",
  primary: "#FF7043",
  primaryRgb: "255, 112, 67",
  primaryGradient: "linear-gradient(225deg, #FF7043, #FF9100)",
  primaryGradient135: "linear-gradient(135deg, #FF7043, #FFAB40)",
  primaryLight: "#FFAB40",
  starColor: "#FFAB40",
  text_primary: "#FFF3E0",
  text_secondary: "#FFCC80",
  card: "#1a1008",
  card_light: "#1e140a",
  cardBg: "rgba(26, 16, 8, 0.85)",
  cardBorder: "rgba(255, 112, 67, 0.12)",
  cardShadow: "rgba(255, 109, 0, 0.12) 0px 4px 24px",
  timelineColor: "#FF7043",
  timelineArrow: "rgba(255, 112, 67, 0.3)",
  button: "#FF7043",
  white: "#FFFFFF",
  black: "#000000",
  navBg: "rgba(13, 9, 6, 0.92)",
  navBorder: "rgba(255, 112, 67, 0.1)",
  loaderBg: "#0d0906",
  footerBg: "#0d0906",
  inputBg: "transparent",
  inputBorder: "#FF7043",
  scrollbarTrack: "#1a1008",
  scrollbarThumb: "#3d2810",
  scrollbarThumbHover: "#5e3d1a",
};

// Cyan Theme (Dark bg, electric cyan accent)
export const cyanTheme = {
  bg: "#060d10",
  bgLight: "#0a1a20",
  bgGradient1: "rgba(0, 188, 212, 0.1)",
  bgGradient2: "rgba(0, 150, 200, 0.08)",
  primary: "#00BCD4",
  primaryRgb: "0, 188, 212",
  primaryGradient: "linear-gradient(225deg, #00BCD4, #26C6DA)",
  primaryGradient135: "linear-gradient(135deg, #00BCD4, #4DD0E1)",
  primaryLight: "#4DD0E1",
  starColor: "#4DD0E1",
  text_primary: "#E0F7FA",
  text_secondary: "#80DEEA",
  card: "#0a161a",
  card_light: "#0e1c22",
  cardBg: "rgba(10, 22, 26, 0.85)",
  cardBorder: "rgba(0, 188, 212, 0.12)",
  cardShadow: "rgba(0, 188, 212, 0.12) 0px 4px 24px",
  timelineColor: "#00BCD4",
  timelineArrow: "rgba(0, 188, 212, 0.3)",
  button: "#00BCD4",
  white: "#FFFFFF",
  black: "#000000",
  navBg: "rgba(6, 13, 16, 0.92)",
  navBorder: "rgba(0, 188, 212, 0.1)",
  loaderBg: "#060d10",
  footerBg: "#060d10",
  inputBg: "transparent",
  inputBorder: "#00BCD4",
  scrollbarTrack: "#0a161a",
  scrollbarThumb: "#153040",
  scrollbarThumbHover: "#204a5e",
};

// Rose Theme (Dark bg, rose/pink accent)
export const roseTheme = {
  bg: "#0d0609",
  bgLight: "#1f0a12",
  bgGradient1: "rgba(233, 30, 99, 0.1)",
  bgGradient2: "rgba(156, 39, 176, 0.06)",
  primary: "#F06292",
  primaryRgb: "240, 98, 146",
  primaryGradient: "linear-gradient(225deg, #F06292, #EC407A)",
  primaryGradient135: "linear-gradient(135deg, #EC407A, #F48FB1)",
  primaryLight: "#F48FB1",
  starColor: "#F48FB1",
  text_primary: "#FCE4EC",
  text_secondary: "#F8BBD0",
  card: "#1a0a10",
  card_light: "#1e0e14",
  cardBg: "rgba(26, 10, 16, 0.85)",
  cardBorder: "rgba(240, 98, 146, 0.12)",
  cardShadow: "rgba(233, 30, 99, 0.12) 0px 4px 24px",
  timelineColor: "#F06292",
  timelineArrow: "rgba(240, 98, 146, 0.3)",
  button: "#F06292",
  white: "#FFFFFF",
  black: "#000000",
  navBg: "rgba(13, 6, 9, 0.92)",
  navBorder: "rgba(240, 98, 146, 0.1)",
  loaderBg: "#0d0609",
  footerBg: "#0d0609",
  inputBg: "transparent",
  inputBorder: "#F06292",
  scrollbarTrack: "#1a0a10",
  scrollbarThumb: "#3d1525",
  scrollbarThumbHover: "#5e2038",
};

// Map of all themes for easy lookup
export const themes = {
  dark: darkTheme,
  light: lightTheme,
  green: greenTheme,
  orange: orangeTheme,
  cyan: cyanTheme,
  rose: roseTheme,
};
